import apiClient from './api-client';

const servicosService = {
    listar: async () => {
        try {
          const response = await apiClient.get('/servicos');
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      obter: async (id) => {
        try {
          const response = await apiClient.get(`/servicos/${id}`);
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      inserir: async (data) => {
        try {
          const response = await apiClient.post('/servicos', data);
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      atualizar: async (id, data) => {
        try {
          const response = await apiClient.patch(`/servicos/${id}`, data);
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      atualizarLote: async (servicos) => {
        try {
          const response = await apiClient.patch(`/servicos/atualizar-lote`, servicos);
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      }
}

export default servicosService;